import { motion } from "framer-motion";

export interface JumpLink {
  label: string;
  href: string;
}

export interface JumpLinksProps {
  links: JumpLink[];
  delay?: number;
}

export default function JumpLinks({ links, delay = 0.3 }: JumpLinksProps) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <motion.nav
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay }}
      className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-sm"
    >
      {links.map((link, i) => (
        <a
          key={i}
          href={link.href}
          onClick={(e) => handleClick(e, link.href)}
          className="text-slate-400 hover:text-white hover:underline transition"
          data-testid={`link-jump-${link.href.replace('#', '')}`}
        >
          {link.label}
        </a>
      ))}
    </motion.nav>
  );
}
